import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { report_invoice_lang } from "../../language/report_invoice";
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url; declare var report_url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  recordsTotal_invoice: number;
  TotalPrice: number;
}

class report {
  customer_id: string;
  customer_name: string;
  place_id: string;
  place_address: string;
  place_type_desc: string;
  fee_type_description: string;
  fee_type_unit: string;
  inform_price: number;
  total_price: number;
}

@Component({
  selector: 'app-report-invoice',
  templateUrl: './report-invoice.component.html',
  styleUrls: ['./report-invoice.component.scss']
})
export class ReportInvoiceComponent implements OnInit {
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  counter = 0;
  months = [
    // {value:0,name_th:'all',n},
    { value: 1, name: { TH: 'มกราคม', EN: "January" } },
    { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
    { value: 3, name: { TH: 'มีนาคม', EN: "March" } },
    { value: 4, name: { TH: 'เมษายน', EN: "April" } },
    { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
    { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
    { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
    { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
    { value: 9, name: { TH: "กันยายน", EN: "September" } },
    { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
    { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
    { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
  ];
  pay_status = [
    { value: 1.1, name: { TH: 'ชำระแล้ว', EN: "Pay" } },
    { value: 2.2, name: { TH: 'ยังไม่ชำระ', EN: "Not Pay" } }
  ]
  types = [
    { value: 1, name: { TH: 'รายวัน', EN: "Report of Daily" } },
    { value: 2, name: { TH: 'รายเดือน', EN: "Report of Month" } },
    { value: 3, name: { TH: 'รายปี', EN: "Report of Year" } },
    // { value: 4, name: { TH: '3 เดือนย้อน', EN: "3 months back" } },
    // { value: 5, name: { TH: '6 เดือนย้อน', EN: "6 months back" } },
    { value: 99, name: { TH: 'ทั้งหมด', EN: "Report of All" } },
    { value: 4, name: { TH: 'ระบุวันเริ่มต้น/สิ้นสุด', EN: "Specify start/end date" } },
    // { value: 98, name: { TH: 'ทั้งหมด (ชำระแล้ว)', EN: "Report of All (Pay)" } },
    // { value: 97, name: { TH: 'ทั้งหมด (ยังไม่ชำระ)', EN: "Report of All (Not Pay)" } }
  ]
  disableSelect = true;
  status_pay = null;
  daysInmonth;
  days;
  type = 2;
  day = new Date().getDay() + 1;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  years: any;
  count = 0;
  interval: any;
  ShowDay: boolean = true;
  ShowMonth: boolean = true;
  ShowYear: boolean = true;
  ShowTable: boolean = false;
  ShowInvoice: boolean = false;
  ShowInformation: boolean = false;
  isLoading = false;
  search_report = '';
  all_reports: any;
  date = {
    start_date: moment(`${moment().add(-1,'year').get('year')}-10-01`).format("YYYY-MM-DD"),
    end_date:moment(`${moment().get('year')}-09-30`).format("YYYY-MM-DD")
  }
  inform_count = '0';
  inform_price = 0;
  inform_price_value = '';
  report = { fee_id: '', customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  request_general: [];
  reports_invoices: any;
  invoices: any;
  all_reports_invoice: any;
  report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
  request_general_id = '';
  submitted = false;
  place_count = null;
  municipality_id = '';
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  reports: report[];

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = report_invoice_lang[this.lang];
  }

  ngOnInit() {
    // debugger
    if (localStorage.getItem('year') != null) {
      this.year = parseInt(localStorage.getItem('year'));
    }

    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
    this.status_pay = 2.2

    this.ShowYear = true;
    this.ShowMonth = true;
    this.ShowDay = false;

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    if (localStorage.getItem('month') != null) {
      if (localStorage.getItem('month').length > 1) {
        this.month = parseInt((localStorage.getItem('month')).match(/"([^']+)"/)[1]);
      }
      else {
        this.month = parseInt(localStorage.getItem('month'));
      }
    }
    if (localStorage.getItem('day') != null) {
      const num = +JSON.parse(localStorage.getItem('day'))
      this.day = num
    }
    if (localStorage.getItem('type') != null) {
      const num = +JSON.parse(localStorage.getItem('type'))
      this.type = num == 1 ? 2 : num == 2 ? 1 : num == 4 ? 4 : num == 5 ? 5 : num == 3 ? 3 : 99
    }
    const date_f = JSON.parse(localStorage.getItem('datefilter'))

    if (this.type == 4 && date_f != undefined) {
      this.ShowYear = false;
      this.ShowMonth = false;
      this.ShowDay = false;
      this.date.end_date = date_f.end_date;
      this.date.start_date = date_f.start_date;
    }


    this.typeChange();
    this.ShowInvoice = false;
    this.ShowInformation = false;
    this.isLoading = false;
    this.ShowTable = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: 'NO Records',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        console.log('reports-new/get_reports_all_invoice_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'reports-new/get_reports_all_invoice_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'report_type': this.type.toString(),
              'day': (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
              'month': (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
              'year': (this.year - 543).toString(),
              'type': (this.type).toString(),
              'cancel': 'false',
              'status_pay': this.status_pay.toString(),
              'date_filter': JSON.stringify(this.date)


            })
          }
          ).subscribe(async resp => {
            //debugger
            const uniqueNumbers = resp.data.map(e => e.place_id).filter((value, index, self) => self.indexOf(value) === index)
            const qw = uniqueNumbers.map(placeId => {
              return resp.data.filter(q => q.place_id === placeId)[0]
            })

            that.reports = resp.data.map((item) => {
              var bathformat = new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
              });

              var numberformat = new Intl.NumberFormat('en-IN', {
                maximumSignificantDigits: 3
              });
              console.log(resp);
              this.inform_count = resp.recordsTotal.toString();
              this.place_count = resp.recordsTotal_invoice.toString();
              this.inform_price = resp.TotalPrice;
              this.inform_price_value = bathformat.format(this.inform_price);
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });

          });
      },
      columns: [{ data: 'cm.customer_id' }, { data: 'cm.customer_name' }, { data: 'fm.place_id' }, { data: 'cp.place_address' },
      { data: 'pty.place_type_description' },  { data: 'fy.fee_type_description' }, { data: 'fy.fee_type_unit' },{ data: '' }]
      //
    };

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = report_invoice_lang[this.lang];
      } else {
        this.language = report_invoice_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  refreshData() {
    if (this.type != 4) {
      localStorage.removeItem('datefilter');
      localStorage.removeItem('type');
    }
    if (this.type == 4) {
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.start_date).format("YYYY-MM-DD") > moment(this.date.end_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.end_date).format("YYYY-MM-DD") < moment(this.date.start_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }

    }

    this.inform_count = "0";
    this.inform_price_value = "0.0";
    this.place_count = "0.0";
    this.ShowTable = false;
    this.isLoading = true;
    this.ShowInvoice = false;
    this.ShowInformation = false;

    setTimeout(() => {
      this.ShowTable = true;
      this.isLoading = false;
    }, 200);
  }


  typeChange() {
    if (this.type == 4 || this.type == 5) {
      this.ShowDay = false;
    }
    switch (this.type.toString()) {
      case '1':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = true;
        break;
      case '2':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = false;
        break;
      case '3':
        this.ShowYear = true;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
      case '99':
      case '98':
      case '97':
        this.ShowYear = false;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
    }
  }

  monthChange() {
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
  }

  show_information(item, type) {
    console.log(item)
    this.ShowInformation = true;
    this.ShowInvoice = false;
    this.ShowTable = false;
    this.report.fee_id = item.fee_id;
    this.report.customer_id = item.customer_id;
    this.report.customer_name = item.customer_name;
    this.report.place_id = item.place_id;
    this.report.place_address = item.place_address;
    this.report.place_type_description = item.place_type_description;
    this.report.fee_type_description = item.fee_type_description;
    this.report.fee_type_unit = item.fee_count + ' ' + item.fee_type_unit;


    this.report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
    this.isLoading = true;
    this.search_report = "";

    this.service.postData({ place_id: this.report.place_id, type: type, month: this.month, day: this.day, year: this.year, status_pay: this.status_pay, date_filter: this.date }, "reports-new/get_reports_invoice").then((result: any) => {
      this.all_reports_invoice = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
      this.reports_invoices = this.all_reports_invoice.filter((item) => {
        var res: any;
        res = item;

        var xy = 0;
        xy = parseInt(moment(item.create_datetime).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

        xy = 0;
        xy = parseInt(moment(item.due_date).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.due_date = moment(item.due_date).format("DD/MM/") + xy;
        res.status_code = item.payment_description
        return res;
      });
      this.all_reports_invoice = this.reports_invoices
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    })
  }

  back() {
    this.ShowInformation = false;
    this.ShowTable = true;
    this.report = { fee_id: "", customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  }

  onSearch_invoice(event) {
    this.reports_invoices = this.all_reports_invoice.filter((item) => {
      return compare(item.invoice_id) || compare(item.fee_description) || compare(item.create_datetime) || compare(item.due_date) || compare(item.total_price) || compare(item.status_code) || compare(item.user_id);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }

  onSearch_place(event) {
    this.reports = this.all_reports.filter((item) => {
      return compare(item.place_id) || compare(item.place_address) || compare(item.place_type_description) || compare(item.fee_type_description) || compare(item.fee_type_unit) || compare(item.customer_id) || compare(item.customer_name);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }


  print_invoice(item) {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    const invoice_id = item.invoice_id;
    // this.service.postData({invoice_id},"invoice/print-invoice").then((result)=>{
    // window.open(report_url + "print-invoice?invoice_id=" + invoice_id + "&municipality_id=" + municipality_id, "_blank");
    window.open(report_url + "print-invoice?invoice_id=" + invoice_id + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");

    // })
  }
  print_invoice_3x4(item) {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    const invoice_id = item.invoice_id;
    // this.service.postData({ invoice_id }, "invoice/print-bill").then((result) => {
    window.open(report_url + "print-invoice-3x4?invoice_id=" + invoice_id + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");

    // window.open(report_url + "print-invoice-3x4?invoice_id=" + invoice_id + "&municipality_id=" + municipality_id, "_blank");
    // })
  }
  print_invoice_allmonth(data) {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    const fee_id = this.report.fee_id;
    // this.service.postData({fee_id},"invoicke/print-invoice").then((result)=>{
    (!data ? window.open(report_url + "print-invoice?place_id=" + this.report.place_id + "&year=" + (this.year.toString()) + "&report=" + this.type.toString() + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank")
      : window.open(report_url + "print-invoice-3x4?place_id=" + this.report.place_id + "&year=" + (this.year.toString()) + "&report=" + this.type.toString() + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank")
    )
    // })
  }

  print_report() {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-invoice?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-invoice?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '4':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '5':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '99':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '98':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '97':
        window.open(report_url + "print-report-invoice?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
    }

  }
  download_excel() {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-invoice-excel?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-invoice-excel?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '4':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '5':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '97':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '98':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '99':
        window.open(report_url + "print-report-invoice-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
    }
  }

  print_invoice_multi_file() {
    localStorage.removeItem("type");

    console.log('11');
    // debugger
    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }
    // debugger
    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-invoice-multi-file?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '2':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '3':
        window.open(report_url + "print-invoice-multi-file?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '4':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '5':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '99':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '98':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '97':
        window.open(report_url + "print-invoice-multi-file?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&status_pay=" + (this.status_pay.toString()) + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
    }
  }

  show_invoice(item) {
    this.ShowInvoice = true;
    this.service.postData({ customer_id: this.report.customer_id, place_id: item.place_id }, "request-general/get").then((result: any) => {
      this.request_general = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      this.service.postData({ invoice_id: item.invoice_id, status_pay: this.status_pay, topic: 'inv', date_filter: this.date, report: this.type }, "invoice/get-invoice-detail").then((result2: any) => {
        this.invoices = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        if (result.data.length > 0) {
          this.disableSelect = false
        }
        else {
          this.disableSelect = true
        }
        this.invoices = this.invoices.filter((item) => {
          var res: any;
          res = item;

          var xy = 0;
          xy = parseInt(moment(item.create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

          xy = 0;
          xy = parseInt(moment(item.due_date).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.due_date = moment(item.due_date).format("DD/MM/") + xy;
          res.status_code = (item.status_code == '02' ? 'ชำระแล้ว' : 'ยังไม่ชำระ')
          return res;
        });

        this.isLoading = false;
      })
    })
  }

  delete() {
    if (this.invoices.length > 0) {
      this.submitted = true;
      if (this.request_general_id != '' && this.request_general_id != undefined) {
        Swal.fire({
          title: this.language.confirm_delete,
          text: this.language.warining_delete,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.want_delete,
          cancelButtonText: this.language.close
        }).then((result) => {
          if (result.value) {
            this.service.postData({ invoice_id: this.invoices[0].invoice_id, bill_id: undefined, request_general_id: this.request_general_id }, "invoice/cancel-invoice").then(result => {
              this.isLoading = false;
              Swal.fire({
                title: this.language.deleted,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then((result) => {
                this.refreshData();
              })
            }, err => {
              window.location.href = this.service.start_host
              this.isLoading = false;
            })
          }
        });
      }
    }

  }


}
